<template lang="pug">
  .add-wa-form
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ category ? $t('edit_category') : $t('add_category') }}

        v-card-text.pa-0
          v-form(ref="form")
            div.pa-4
              .form-name
                p.mb-1.label.basic600--text.text-uppercase {{ $t('form_name.label') }}
                v-text-field.mt-2(
                  v-model="name"
                  outlined dense persistent-hint counter
                  maxlength="50"
                  background-color="basic200"
                  :placeholder="$t('form_name.placeholder')"
                  :rules="rules.not_empty")

              v-layout.mt-4
                p.h6.basic1000--text.mb-0 {{ $t('attach_products') }}
                v-spacer
                v-btn.button-AA-tiny(
                  outlined x-small
                  height="24"
                  color="textColorAccent"
                  :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}"
                  @click='showAttachProductsDialog = true')

                  v-icon.mr-1(small) mdi-plus
                  | {{ $t('add_product') }}

              .attach-product.mt-2
                p.mb-1.label.basic600--text.text-uppercase {{ $t('products') }}

                v-select.mt-2.mb-8(
                  v-model="products"
                  outlined dense readonly hide-no-data chips hide-details multiple
                  ref="selectProducts"
                  type="button"
                  append-icon=""
                  :items="products"
                  :menu-props="({ 'closeOnContentClick': false})"
                  :loading="productSearchLoading"
                  background-color="basic200"
                  placeholder="Add Products")

                  template(v-slot:selection="{ attrs, item, select, selected }")
                    v-chip.mt-1.s2(
                      outlined small close
                      close-icon="mdi-close"
                      v-bind="attrs"
                      :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`"
                      :color="item.status === 'draft' ? 'danger' : 'basic600'"
                      :input-value="selected"
                      @click:close="removeProd(item)")

                      span(v-if="item.name") {{ item.name.length > 25 ? (item.name.substr(0,25) + '...') : item.name }}{{ item.status === 'draft' ? ' (draft)' : '' }}

              //- .enabled
                p.mb-1.label.basic600--text.text-uppercase {{ enabled ? 'ENABLED': 'DISABLED'}}
                y-switch.ma-0.pa-0(v-model="enabled")
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text Cancel
          v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-small.basic100--text(v-if="category") {{ $t('save') }}
            .button-AA-small.basic100--text(v-else) {{ $t('create') }}
    
    .modals
      attach-products(v-if="showAttachProductsDialog" :open.sync="showAttachProductsDialog" :initialProducts.sync="products")

</template>

<script>
import { mapActions } from 'vuex'
import AttachProducts from '@/components/dialogs/AttachProducts.vue'
export default {
  name: 'AddProductCategories',
  props: ['open', 'company', 'category'],
  components: { AttachProducts },
  data: () => ({
    name: null,
    products: [],
    enabled: true,
    productSearchLoading: false,
    showAttachProductsDialog: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    },
    prod_keyboard: false,
    isLoading: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    currentCategory: {
      get() {
        return this.category
      },
      set(newValue) {
        this.$emit('update:category', newValue)
      }
    }
  },
  mounted () {
    if (this.category) {
      this.fetchProducts()
    }
    if (this.category) {
      this.name = this.category.name
      this.enabled = this.category.enabled
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchProducts () {
      this.productSearchLoading = true
      this.$axios.get(`/product_categories/${this.category.id}/products/?page_size=-1`)
        .then(resp => {
          if (resp.data.results) {
            this.products = resp.data.results
          }
        })
        .catch(() => {})
        .finally(() => {
          this.productSearchLoading = false
        })
    },
    getSearchText (item) {
      return item.name + ' ' + item.description
    },
    getMemberSearchText (item) {
      return item.user.first_name + ' ' + item.user.last_name + ' ' + item.user.email
    },
    handleDeleteItem (index) {
      this.extraFields.splice(index, 1)
    },
    handleFieldAdded (field) {
      this.extraFields.push(field)
    },
    handleFieldEdited (field, index) {
      this.extraFields[index] = field
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        company : this.company.id,
        parent : null,
        name : this.name,
        enabled: this.enabled
      }
      var productIds = []
      if (this.products.length != 0) {
        this.products.forEach(item => {
          if (item.id) {
            productIds.push(item.id)
          }
        })
      }
      params['products'] = productIds
      if (this.category) {
        this.axios.put(`/product_categories/${this.category.id}/`, params)
        .then(resp => {
          this.currentCategory = resp.data
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.category_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/product_categories/`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.category_created')])
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    removeProd (item) {
      let index = this.products.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.products.splice(index, 1)
      this.$refs.selectProducts.isMenuActive = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "form_name": {
      "label": "Category Name",
      "placeholder": "Write category name here"
    }
  },
  "id": {
    "form_name": {
      "label": "Nama Kategori",
      "placeholder": "Tulis Nama Kategori di sini"
    }
  }
}
</i18n>
